<template>
  <div>
    <el-button type="primary" class="update" @click="clickUpdate" :disabled="editDisabled">更新</el-button>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    editDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    clickUpdate () {
      this.$emit('update')
    }
  }
}
</script>

<style lang="scss" scoped>
.update {
  width: 8em;
}
</style>
